import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Link, useHistory, useParams } from 'react-router-dom'
import { XIcon } from '@heroicons/react/outline'
import { topBarStore } from '../../../../../lib/stores/TopBarStore'
import { HOME } from '../../../../routing/paths'
import SuccessMessage from '../../../../components/SuccessMessage'
import CaselessPaymentSuccessStore from './CaselessSuccessPaymentStore'
import FrequentlyAskedQuestionsModal from '../../../../components/FAQ'
import Spinner from '../../../../components/Spinner'

const CaseSuccess = () => {
  const history = useHistory()
  const { operation } = useParams()
  const [viewFAQModal, setViewFAQModal] = useState(false)
  const [caselessPaymentSuccessStore] = useState(() => new CaselessPaymentSuccessStore())

  const showFAQModal = (e) => {
    e.stopPropagation()
    e.preventDefault()
    setViewFAQModal(true)
  }

  const hideFAQModal = () => {
    setViewFAQModal(false)
  }

  useEffect(async () => {
    topBarStore.setActionIcon(
      <Link to={HOME}>
        <XIcon className="h-6 w-6" />
      </Link>
    )

    await caselessPaymentSuccessStore.fetchFrequentlyAskedQuestions(operation)

    return () => topBarStore.reset()
  }, [])

  if (caselessPaymentSuccessStore.isLoading) {
    return <Spinner />
  }

  return (
    <>
      <SuccessMessage
        subtitle={<div className='text-gray-600'>Thank you for working with BootVision</div>}
        title="Your payment has been successfully completed!"
        footer={
          <span>
            Questions? Read our{' '}
            <b className="cursor-pointer" onClick={showFAQModal}>
              FAQ
            </b>
          </span>
        }
      />
      <FrequentlyAskedQuestionsModal
        faq={caselessPaymentSuccessStore.faq}
        open={viewFAQModal}
        handleClose={hideFAQModal}
      />
    </>
  )
}

export default observer(CaseSuccess)
